import { usePermissions, useIamPermission } from "@/features/auth/hooks/usePermissions";

/**
 * True when the caller can use marketplace admin catalog tools (vendor list,
 * pending onboarding, import). Matches API page-bundle inheritance: holding
 * the admin page or any legacy vendor-catalog action is enough.
 */
export function useMarketplaceAdminCapability(): boolean {
  const perms = usePermissions();
  return (
    useIamPermission(perms.MARKETPLACE_ADMIN_VIEW_PAGE) ||
    useIamPermission(perms.MARKETPLACE_ADMIN_LIST_VENDORS) ||
    useIamPermission(perms.MARKETPLACE_ADMIN_LIST_PENDING_HANDOFFS) ||
    useIamPermission(perms.MARKETPLACE_ADMIN_CREATE_VENDOR) ||
    useIamPermission(perms.MARKETPLACE_ADMIN_REPLACE_VENDOR)
  );
}
